import React, { FC, useEffect } from 'react';
import { Skeleton } from 'src/common';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';
import { OverviewQp, ProcurementsDisplay } from 'src/models/procurements/types';
import TendersStarred from './TendersStarred';
import TendersScreening from './TendersScreening';
import TendersAll from './TendersAll';
import BidsPage from 'src/pages/BidsPage';
import CreateWorkspace from 'src/pages/BidsPage/CreateWorkspace';
import { ArchivedWorkspaces } from 'src/pages/BidsPage/ArchivedWorkspaces';
import DocumentsLibraryPage from 'src/pages/DocsLibraryPage';
import CallOffsPage from 'src/pages/CallOffsPage';
import { FeatureFlag, updateQueryParams, useFeatureFlag, useQueryParams } from 'src/helpers';
import { useActiveMpIdState } from 'src/models/matchingProfiles/hooks';

export const TendersPage: FC = () => {
  const procurementTabInfo = useOverviewMode();
  const isMonitoringProfilesFeature = useFeatureFlag(FeatureFlag.MonitoringProfiles);
  const [mpId] = useActiveMpIdState();
  const qp = useQueryParams();

  useEffect(() => {
    const currentQpKeys = Object.keys(qp);
    if (
      mpId &&
      (!currentQpKeys.length ||
        (!currentQpKeys.includes(OverviewQp.MatchingProfileId) && qp[OverviewQp.Tab] === ProcurementsDisplay.MATCHED))
    ) {
      if (isMonitoringProfilesFeature) {
        updateQueryParams({ [OverviewQp.Tab]: ProcurementsDisplay.MATCHED, [OverviewQp.MatchingProfileId]: mpId });
      } else {
        updateQueryParams({ [OverviewQp.Tab]: ProcurementsDisplay.ALL });
      }
    }
  }, [isMonitoringProfilesFeature, mpId, qp]);

  return !procurementTabInfo ? (
    <Skeleton active loading />
  ) : (
    <>
      {procurementTabInfo.tab === ProcurementsDisplay.ALL && <TendersAll key={JSON.stringify(procurementTabInfo)} />}
      {procurementTabInfo.tab === ProcurementsDisplay.MARKED && (
        <TendersStarred key={JSON.stringify(procurementTabInfo)} />
      )}
      {procurementTabInfo.tab === ProcurementsDisplay.MATCHED && !!isMonitoringProfilesFeature && <TendersScreening />}
      {procurementTabInfo.tab === ProcurementsDisplay.WORKSPACE && <BidsPage />}
      {procurementTabInfo.tab === ProcurementsDisplay.CALL_OFFS && <CallOffsPage />}
      {procurementTabInfo.tab === ProcurementsDisplay.WORKSPACE_CREATING && <CreateWorkspace />}
      {procurementTabInfo.tab === ProcurementsDisplay.ARCHIVED_WORKSPACES && <ArchivedWorkspaces />}
      {procurementTabInfo.tab === ProcurementsDisplay.DOCUMENTS_LIBRARY && <DocumentsLibraryPage />}
    </>
  );
};

export default TendersPage;
